
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/information",
      function () {
        return require("private-next-pages/company/information/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/information"])
      });
    }
  